export enum NotificationType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  PERSISTENT = 'PERSISTENT',
}
